import Decades from './CenturyView/Decades.tsx';

type CenturyViewProps = React.ComponentProps<typeof Decades>;

/**
 * Displays a given century.
 */
export default function CenturyView(props: CenturyViewProps): React.ReactElement {
  function renderDecades() {
    return <Decades {...props} />;
  }

  return <div className="react-calendar__century-view">{renderDecades()}</div>;
}
